import { ReviewPresenter } from '@/presentation/presenters/review/reviewPresenter'
import { CloseReviewEntryViewModel } from '@/presentation/viewmodels/review/closeReviewEntryViewModel'
import { OpenReviewEntryViewModel } from '@/presentation/viewmodels/review/openReviewEntryViewModel'
import { ReviewEntryDetailViewModel } from '@/presentation/viewmodels/review/reviewEntryDetailViewModel'
import { ReviewPageStateViewModel } from '@/presentation/viewmodels/review/reviewPageStateViewModel'

export function useReviewPresenter(
  presenter: ReviewPresenter = new ReviewPresenter(
    new ReviewPageStateViewModel(),
    new ReviewEntryDetailViewModel(),
    new OpenReviewEntryViewModel(),
    new CloseReviewEntryViewModel()
  )
) {
  return {
    isLoading: presenter.isLoading,
    initState: presenter.initState.bind(presenter),
    postCloseEntry: presenter.postCloseEntry.bind(presenter),
    postEvaluationReview: presenter.postEvaluationReview.bind(presenter),
    clickEntrySummary: presenter.clickEntrySummary.bind(presenter),
    getEntryDetail: presenter.getEntryDetail.bind(presenter),
    isAiReview: presenter.isAiReview.bind(presenter)
  }
}
